import { ImgHTMLAttributes } from "react"
import logo from "../../img/logo.png"

export const Logo = (props: LogoProps) => {
  return <img src={logo} {...props} />
}

export type LogoProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "src">
